import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import fuelConsumption from '@src/services/fuelConsumption/fuelConsumption.services';

export const getVehicleFuelTransaction = createAsyncThunk(
  'getVehicleFuelTransaction',
  async (body, { getState, rejectWithValue }) => {
    try {
      const {
        VouId = 4,
        PageNumber = 1,
        PageSize = 10,
        CustomerId = null,
        plateNumber = null,
        vehicleId = null,
        vehicleDepartmentId = null,
        addressId = null,
        deviceTypeId = null,
        costCenterId = null,
        startDate = null,
        endDate = null,
      } = body;

      const custId = CustomerId ?? (await getState()?.customer?.selectedCustomer?.customerId);
      const res = await fuelConsumption.getVehicleFuelTransaction({
        VouId,
        PageNumber,
        PageSize,
        CustomerId: custId,
        plateNumber,
        vehicleId,
        vehicleDepartmentId,
        addressId,
        deviceTypeId,
        costCenterId,
        startDate,
        endDate,
      });
      return res;
    } catch (error) {
      return rejectWithValue(error?.data);
    }
  },
);

export const downloadVehicleFuelTransactionsFile = createAsyncThunk(
  'downloadVehicleFuelTransactionsFile',
  async (body, { getState, rejectWithValue }) => {
    try {
      const { VouId = 4, CustomerId = null } = body;

      const custId = CustomerId ?? (await getState()?.customer?.selectedCustomer?.customerId);
      const res = await fuelConsumption.downloadVehicleFuelTransactionsFile({
        VouId,
        CustomerId: custId,
      });
      return res;
    } catch (error) {
      console.log('error', error);
      return rejectWithValue(error?.data);
    }
  },
);

export const downloadVehicleFuelTransactionsPDFFile = createAsyncThunk(
  'downloadVehicleFuelTransactionsPDFFile',
  async (body, { getState, rejectWithValue }) => {
    try {
      const { VouId = 4, CustomerId = null } = body;

      const custId = CustomerId ?? (await getState()?.customer?.selectedCustomer?.customerId);
      const res = await fuelConsumption.downloadVehicleFuelTransactionsPDFFile({
        VouId,
        CustomerId: custId,
      });
      return res;
    } catch (error) {
      console.log('error', error);
      return rejectWithValue(error?.data);
    }
  },
);

const initialState = {
  fuelConsumptions: [],
  loading: {
    fuelConsumptions: false,
  },
  pagedProperty: {
    pageSize: 0,
    totalItems: 0,
    currentPage: 1,
  },
};

export const fuelConsumptionSlice = createSlice({
  name: 'fuelConsumption',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getVehicleFuelTransaction.pending, (state) => {
        state.loading.fuelConsumptions = true;
      })
      .addCase(getVehicleFuelTransaction.fulfilled, (state, action) => {
        state.loading.fuelConsumptions = false;
        state.fuelConsumptions = action?.payload?.data || [];
        state.pagedProperty.pageSize =
          (action?.payload?.message
            ? parseInt(parseInt(action?.payload?.message, 10) / 10, 10) + 1
            : 0) || 0;
        state.pagedProperty.totalItems = action?.payload?.message
          ? parseInt(action?.payload?.message, 10)
          : 0;
        state.pagedProperty.currentPage = action?.payload?.currentPage || 1;
      })
      .addCase(getVehicleFuelTransaction.rejected, (state, action) => {
        state.loading.fuelConsumptions = false;
        state.fuelConsumptions = [];
        state.pagedProperty = {
          pageSize: 0,
          totalItems: 0,
          currentPage: 1,
        };
        state.error = action.payload || 'Error';
      });
  },
});
